'use client';

import {
  CSSProperties,
  JSXElementConstructor,
  ReactElement,
  ReactNode,
} from 'react';

import { Property } from 'csstype';
import RCTooltip from 'rc-tooltip';

import 'rc-tooltip/assets/bootstrap_white.css';

import palette from '@utils/theme/palette';

import { Placement } from './types';
import { AnimatedContent, Container, TooltipStyles } from './styled';

export interface TooltipProps {
  children: ReactElement<any, string | JSXElementConstructor<any>> | undefined;
  content: ReactNode;
  title: ReactNode | (() => ReactNode);
  textAlign?: Property.TextAlign;
  trigger?: 'click' | 'hover' | 'focus';
  overlayInnerStyle?: CSSProperties;
  overlayStyle?: CSSProperties;
  placement?: Placement;
  showArrow?: boolean;
  open?: boolean;
  onOpenChange?: (open?: boolean) => void;
  getPopupContainer?: ((node: HTMLElement) => HTMLElement) | undefined;
  arrowColor?: string;
  zIndex?: number;
  borderRadius?: string;
  arrowLeft?: number;
}

const defaultGetPopupContainer = () => document.body;

const Tooltip = ({
  children,
  title,
  trigger = 'hover',
  overlayInnerStyle,
  placement,
  showArrow = true,
  open,
  onOpenChange,
  getPopupContainer = defaultGetPopupContainer,
  arrowColor,
  borderRadius,
  arrowLeft,

  ...others
}: Partial<TooltipProps>) => {
  return (
    <>
      <Container
        arrowColor={arrowColor ? arrowColor : palette.darkGrey}
        arrowLeft={arrowLeft}
      >
        <TooltipStyles
          arrowColor={arrowColor ? arrowColor : palette.darkGrey}
        />
        <RCTooltip
          getTooltipContainer={getPopupContainer}
          placement={placement}
          trigger={trigger}
          {...others}
          overlay={
            typeof title === 'function' ? (
              <AnimatedContent> {title()} </AnimatedContent>
            ) : (
              <AnimatedContent>{title}</AnimatedContent>
            )
          }
          overlayInnerStyle={{
            backgroundColor: palette.darkGrey,
            color: palette.white,
            borderRadius: borderRadius ? borderRadius : '8px',
            padding: '10',
            height: 'fit-content',
            border: 'none',
            boxShadow:
              '0 3px 6px -4px rgba(0,0,0,.12), 0 6px 16px 0 rgba(0,0,0,.08), 0 9px 28px 8px rgba(0,0,0,.05)',
            ...overlayInnerStyle,
          }}
          showArrow={placement === 'auto' ? false : showArrow}
          visible={!title ? false : open}
          onVisibleChange={onOpenChange}
        >
          {children || <></>}
        </RCTooltip>
      </Container>
    </>
  );
};

export default Tooltip;
